import { createInterfaceId } from "@gitlab/needle";
//#region src/otel_service.ts
/**
* Abstraction over OpenTelemetry that allows each consumer (VS Code extension,
* CLI, language service) to provide host-specific resource attributes while
* sharing the core tracing/metrics logic.
*/
const OTelService = createInterfaceId("OTelService");
//#endregion
//#region src/trackers/extension_activity_tracker.ts
const EXTENSION_ACTIVITY_CATEGORY = "gitlab_extension_activity";
let EXTENSION_ACTIVITY_EVENT = /* @__PURE__ */ function(EXTENSION_ACTIVITY_EVENT) {
	EXTENSION_ACTIVITY_EVENT["ActiveInstallation"] = "active_installation";
	return EXTENSION_ACTIVITY_EVENT;
}({});
const ExtensionActivitySnowplowTracker = createInterfaceId("ExtensionActivitySnowplowTracker");
//#endregion
export { OTelService as i, EXTENSION_ACTIVITY_EVENT as n, ExtensionActivitySnowplowTracker as r, EXTENSION_ACTIVITY_CATEGORY as t };

//# sourceMappingURL=extension_activity_tracker-BO5QIfPu.mjs.map